import { useQuery } from "@tanstack/react-query"
import { assessmentsHooks } from "pages/School/Assessments"
import { getTranscriptionUsersFetch } from "store/middlewares/user.crud"
import qc from "keys/queryClient"
import SelectSemesterAndYear, { getSemesterAndYearLabel } from "components/SelectSemesterAndYear/SelectSemesterAndYear"

const useFilterItems = ({ monthOptions } = {}) => {
    const headerItems = assessmentsHooks.useHeaderItems()

    const transcriptionUsers = useQuery({
        queryKey: [qc.transcriptionUsers],
        queryFn: async ({ signal }) => {
            const { data } = await getTranscriptionUsersFetch()
            return data
        }
    })

    const filterItems = [
        // multiple+readOnlyInput: בחירה מרובה עם רשימת אייקונים (CategoriesOptions), כמו בפילטר "סוג מבדק" במסך חיתוך אודיו
        { ...headerItems.category, name: "categories", multiple: true, readOnlyInput: true, pillStyle: true, pillLabel: "קטגוריה" },
        { ...headerItems.assessment_def, pillStyle: true, pillLabel: "שם מבדק" },
        // placeholder לשלב 2 - עוד לא ברור אילו נתונים/ערכים יעמדו מאחורי הסינון הזה
        {
            name: "transcription_stage",
            component: "autoComplete",
            options: [],
            disabled: true,
            pillStyle: true,
            pillLabel: "שלב מתעתקת",
            dividerBefore: true,
        },
        {
            name: "marking_words_update_by",
            component: "autoComplete",
            placeholder: "בחר מתעתקת",
            options: transcriptionUsers.data,
            pillStyle: true,
            pillLabel: "מתעתקת",
        },
        // "חודשים" = חודש+שנה בהם הסתיים סימון המילים בפועל (marking_words_end_date), נגזר דינמית מהנתונים ולא מהסמסטרים
        {
            name: "marking_end_months",
            component: "autoComplete",
            multiple: true,
            placeholder: "בחר חודשים",
            options: monthOptions || [],
            pillStyle: true,
            pillLabel: "חודשים",
            dividerBefore: true,
        },
        {
            name: "semester_and_year",
            component: "autoComplete",
            placeholder: "בחר שנה וסמסטר",
            getOptionLabel: getSemesterAndYearLabel,
            paperComponent: SelectSemesterAndYear,
            pillStyle: true,
            pillLabel: "שנה וסמסטר",
            dividerBefore: true,
        },
        // placeholder לשלב 2 - אין עדיין שדה/משמעות במערכת
        {
            name: "optimization_type",
            component: "autoComplete",
            options: [],
            disabled: true,
            pillStyle: true,
            pillLabel: "סוג ייעול",
        },
    ]

    return filterItems
}

export default useFilterItems
